import React from 'react';

import { EPublisherSolutionModelSubType } from 'common/contracts';

import { ESideBarContext } from '../../types';
import { getIconByContext } from '../../utils';

interface AppchargeIconProps {
  context: ESideBarContext;
  size?: number;
  isCheckout?: boolean;
  projectSubType?: EPublisherSolutionModelSubType;
  isParkingDomain?: boolean;
}

const AppchargeIcon: React.FC<AppchargeIconProps> = ({
  context,
  size = 20,
  isCheckout,
  projectSubType,
  isParkingDomain
}) => {
  const renderIcon = () => {
    switch (context) {
      case ESideBarContext.PROJECT:
        return getIconByContext(context, isCheckout, projectSubType);
      case ESideBarContext.PORTAL:
        return getIconByContext(context, false, undefined, isParkingDomain);
      case ESideBarContext.PORTAL_LEVEL_STORE:
        return getIconByContext(context, false);
      default:
        return (
          <img
            src={'./assets/icons/ac-black-green-icon.png'}
            alt={`${context} icon`}
            className="w-5 h-5 object-contain"
            style={{ borderRadius: '6px' }}
          />
        );
    }
  };

  return renderIcon();
};

export default AppchargeIcon;
